module.exports = __webpack_public_path__ + "static/media/comunity.eed219e4.svg";